import { render } from "./Campaigns.vue?vue&type=template&id=07582bbd&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"

import "./Campaigns.vue?vue&type=style&index=0&id=07582bbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07582bbd"]])

export default __exports__